/*
 * @Descripttion: zzy
 * @version:  v3.2
 * @Author: zzy
 * @Date: 2025-06-20 13:55:52
 * @LastEditors: zzy
 * @LastEditTime: 2026-03-13 15:03:34
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/login.vue')
    },
    {
        path: '/loginopc',
        name: 'loginopc',
        component: () => import('../views/login/loginOPC.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/login/register.vue')
    },
    {
        path: '/reset',
        name: 'reset',
        component: () => import('../views/login/reset.vue')
    },
    {
        path: '/serviceAgreement',
        name: 'serviceAgreement',
        component: () => import('../views/login/serviceAgreement.vue')
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/index.vue')
    },
    {
        path: '/registration',
        name: 'registration',
        component: () => import('../views/registrationApplication.vue'),
    },
    {
        path: '/registrationInfoOPC',
        name: 'registrationInfoOPC',
        component: () => import('../views/userCenter/components/registrationInfoOPC.vue')
    },
    {
        path: '/userCenter',
        name: 'userCenter',
        component: () => import('../views/userCenter/index.vue')
    },
    {
        path: '/editUserInfo',
        name: 'editUserInfo',
        component: () => import('../views/userCenter/components/editUserInfo.vue')
    },
    {
        path: '/mineProjectOPC',
        name: 'mineProjectOPC',
        component: () => import('../views/userCenter/components/mineProjectOPC.vue')
    },
    {
        path: '/registrationInfo',
        name: 'registrationInfo',
        component: () => import('../views/userCenter/components/registrationInfo.vue')
    },
    {
        path: '/enServices',
        name: 'enServices',
        component: () => import('../views/enServices.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/aboutUs.vue')
    },
    {
        path: '/office',
        name: 'office',
        component: () => import("../views/screen/office.vue")
    },
    {
        path: '/meeting',
        name: 'meeting',
        component: () => import("../views/screen/meeting.vue")
    },
    {
        path: '/bpImg',
        name: 'bpImg',
        component: () => import("../views/bpImg.vue")
    },
]

const router = new VueRouter({
    routes
})

export default router
